import { Component, OnInit, Input } from '@angular/core';
import { LMSDataService } from 'lms-api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-author-bio-modal',
  templateUrl: './author-bio-modal.component.html',
  styleUrls: ['./author-bio-modal.component.scss']
})
export class AuthorBioModalComponent implements OnInit {
  @Input() public authorId;
  public author$;

  constructor(private lmsDataService: LMSDataService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.author$ = this.lmsDataService.GetAuthor(this.authorId);
  }

}
